<template>
  <div v-if="!editing" @click="startEdit" style="cursor: pointer; min-height: 24px;">
    {{ floatNumber(value) || '0.00' }}
  </div>
  <div v-else style="display: flex; align-items: center; gap: 4px;">
    <v-select
      v-model="localValue"
      :items="hoursOptions"
      dense
      hide-details
      solo
      style="max-width: 80px;"
      @keyup.enter="save"
      ref="selectInput"
    />
    <v-btn
      icon
      x-small
      color="success"
      @click="save"
      :loading="saving"
    >
      <v-icon x-small>mdi-check</v-icon>
    </v-btn>
    <v-btn
      icon
      x-small
      color="error"
      @click="cancel"
    >
      <v-icon x-small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "InlineHoursEditor",
  props: {
    value: [String, Number],
    item: Object,
    hoursOptions: {
        type:Array,
    }
  },
  data() {
    return {
      editing: false,
      localValue: this.value,
      saving: false,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    hoursOptions(newVal) {
      // Si las opciones cambian, reiniciamos el valor local
      if (!newVal.includes(this.localValue)) {
        this.localValue = this.value;
      }
    }
  },
  methods: {
    startEdit() {
      this.editing = true;
      this.localValue = this.value;
      this.$nextTick(() => {
        if (this.$refs.selectInput) {
          this.$refs.selectInput.focus();
        }
      });
    },
    async save() {
      if (this.localValue === this.value) {
        this.cancel();
        return;
      }
      
      this.saving = true;
      try {
        // Emite el evento con el nuevo valor y el item
        this.$emit('save', {
          item: this.item,
          newValue: this.localValue,
          oldValue: this.value
        });
        this.editing = false;
      } catch (error) {
        console.error('Error al guardar:', error);
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      this.editing = false;
      this.localValue = this.value;
    },
    floatNumber(value) {
      if (value === null || value === undefined) return '';
      return parseFloat(value).toFixed(2);
    }
  }
};
</script>